import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { User } from '@feathr/blackbox';
import { Role } from '@feathr/blackbox';
import { Select, toast } from '@feathr/components';
import { useAccount } from '@feathr/extender/state';
import useUser from '@feathr/extender/state/useUser';

interface IProps {
  user: User;
}

function RoleSelect({ user }: IProps): JSX.Element {
  const currentUser = useUser();
  const account = useAccount();

  const options = [
    {
      id: Role.admin,
      name: 'Admin',
    },
    {
      id: Role.normie,
      name: 'User',
    },
  ];

  const acl = account?.get('acl');
  const aclItem = toJS(acl.find((i) => i.user_id === user.id));

  const value = aclItem?.role === Role.admin ? options[0] : options[1];

  async function handleChangeUserRole(option: { id: Role; name: string }) {
    account.set({
      acl: [...acl.filter((i) => i.user_id !== user.id), { user_id: user.id, role: option.id }],
    });
    const patchedAccount = await account.patchDirty();
    if (!patchedAccount?.isErrored) {
      toast('User role was updated.', { type: 'success' });
    } else {
      toast("Something went wrong while updating the user's role!", { type: 'error' });
    }
  }

  return (
    <Select
      disabled={user.id === currentUser.id}
      onSelectSingle={handleChangeUserRole}
      options={options}
      value={value}
    />
  );
}

export default observer(RoleSelect);
